export default __webpack_public_path__ + "static/media/screen_google_calendar_07.69e4118c.png";